import React, { useEffect } from "react";
import BlogsList from "./blogs-list/BlogsList";
import BlogCategories from "./BlogCategories";
import RecentPost from "./RecentPost";
import Tags from "./Tags";
import SearchBlogs from "./SearchBlogs";
import Hero from "../common/components/Hero";

const Blogs = () => {
  const list = [
    { title: "", component: <SearchBlogs /> },
    { title: "Blog Categories", component: <BlogCategories /> },
    { title: "Recent Post", component: <RecentPost /> },
    { title: "Tags", component: <Tags /> },
  ];
  useEffect(() => {
    document.getElementById("title-page").innerHTML = "Make My Way | Blogs";
  }, []);
  return (
    <div className="pb-48">
      <Hero value={8} />
      <div
        id="blogs-top"
        className="py-14 sm:py-16 md:py-24 lg:py-28 xl:py-[140px] container"
      >
        <div className="flex flex-wrap gap-y-6 max-lg:flex-col-reverse justify-between">
          <div className="lg:w-[59.6%]">
            <BlogsList />
          </div>
          <div className="lg:w-[37%] xl:w-4/12">
            <div className="flex flex-col gap-y-4 md:gap-y-6  lg:sticky lg:top-28">
              {list.map((obj, index) => (
                <div
                  key={index}
                  className="p-4 md:p-5 bg-[#F7F7F7] rounded-[10px]"
                >
                  {obj.title && (
                    <h2 className="text-custom-black text-lg !leading-150 font-semibold relative after:absolute after:h-px after:left-0 after:w-full after:bg-custom-black after:top-full inline-block mb-3 md:mb-3.5 pb-1.5">
                      {obj.title}
                    </h2>
                  )}
                  {obj.component}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default Blogs;
